import { z } from "zod";
import type { MINUTES } from "../date-time/time-constants";

type TimePadding = {
    startInMinutes: MINUTES;
    endInMinutes: MINUTES;
};

const timePaddingZodSchema: z.ZodSchema<TimePadding> = z.object({
    startInMinutes: z
        .number()
        .min(0)
        .max(1439) as unknown as z.ZodSchema<MINUTES>,
    endInMinutes: z
        .number()
        .min(0)
        .max(1439) as unknown as z.ZodSchema<MINUTES>,
});

export { timePaddingZodSchema };
export type { TimePadding };
